import React, { useEffect, useState } from 'react'
import {
  Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, makeStyles
} from '@material-ui/core'
import api from '../../api/client'
import { toFarsiDigits } from '../../assets/utils'

const useStyles = makeStyles(() => ({
  wrap: { overflowX: 'auto', border: '1px solid #e3e6f2', borderRadius: 10 },
  headCell: {
    background: '#1a237e', color: '#fff', fontWeight: 700, fontSize: 11.5,
    whiteSpace: 'nowrap', padding: '8px 10px',
  },
  cell: { fontSize: 12, padding: '8px 10px', whiteSpace: 'nowrap' },
}))

const ROLE_LABEL = {
  Contractor: 'پیمانکار',
  Consultant: 'مشاور',
  Supervisor: 'ناظر',
  Department: 'سازمان',
  Admin: 'ادمین',
}

/**
 * گزارشِ «بازدیدِ یک قرارداد» — چه کسانی و چند بار آن قرارداد را باز کرده‌اند.
 * فقط ادمین به این گزارش دسترسی دارد.
 */
export default function ContractOpensDialog({ open, onClose, contractId, contractNumber }) {
  const classes = useStyles()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    if (!open || !contractId) return undefined
    let alive = true
    setLoading(true)
    setErr('')
    api.get(`contracts/opens-report/?contract_id=${contractId}`)
      .then((res) => { if (alive) setData(res.data) })
      .catch((e) => {
        if (alive) setErr((e && e.response && e.response.data && e.response.data.detail) || 'خطا در دریافت گزارش')
      })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [open, contractId])

  const rows = (data && data.users) || []

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="lg" fullWidth style={{ direction: 'rtl' }}>
      <DialogTitle style={{ fontWeight: 800, color: '#1a237e' }}>
        گزارشِ بازدیدِ قرارداد {toFarsiDigits(contractNumber || (data?.contract?.number) || '')}
      </DialogTitle>
      <DialogContent dividers>
        {loading && <Box textAlign="center" style={{ padding: 20 }}><CircularProgress /></Box>}
        {err && <Typography color="error">{err}</Typography>}

        {!loading && data && (
          <>
            <Typography variant="body2" style={{ color: '#5a6b8c', marginBottom: 8 }}>
              {data.contract?.organization ? `سازمان: ${toFarsiDigits(data.contract.organization)} · ` : ''}
              مجموعِ باز کردن: <b>{toFarsiDigits(data.total_opens || 0)}</b> مرتبه توسط{' '}
              <b>{toFarsiDigits(rows.length)}</b> کاربر
            </Typography>
            <TableContainer className={classes.wrap} component={Paper}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headCell} align="center">کاربر</TableCell>
                    <TableCell className={classes.headCell} align="center">نام</TableCell>
                    <TableCell className={classes.headCell} align="center">نقش</TableCell>
                    <TableCell className={classes.headCell} align="center">تعداد باز کردن</TableCell>
                    <TableCell className={classes.headCell} align="center">آخرین بازدید</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((r) => (
                    <TableRow key={r.user_id}>
                      <TableCell className={classes.cell} align="center" dir="ltr">{toFarsiDigits(r.username)}</TableCell>
                      <TableCell className={classes.cell} align="center">{toFarsiDigits(r.name)}</TableCell>
                      <TableCell className={classes.cell} align="center">
                        {toFarsiDigits(ROLE_LABEL[r.role] || r.role)}
                        {r.role2 ? ` + ${toFarsiDigits(ROLE_LABEL[r.role2] || r.role2)}` : ''}
                      </TableCell>
                      <TableCell className={classes.cell} align="center">
                        <b>{toFarsiDigits(r.count)}</b>
                      </TableCell>
                      <TableCell className={classes.cell} align="center">
                        {toFarsiDigits((r.last_seen || '').replace('T', ' ').slice(0, 16))}
                      </TableCell>
                    </TableRow>
                  ))}
                  {!rows.length && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <Typography>این قرارداد هنوز باز نشده است.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" style={{ fontWeight: 'bold' }}>
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  )
}
